<template>
  <div class="customerbox">
      <b-card class="vh-30 scroll my-3" border-variant="info">
        <b-icon icon="person" font-scale="3" class="float-right" variant="info"></b-icon>

        <b-table :items="affectedPersonCandidates" :fields="fields" :tbody-tr-class="rowClass">
          <template v-slot:cell(info)="row">

            <b-button v-if="row.item.status=='selected'" variant="outline-secondary" size="sm" @click="row.toggleDetails" class="mr-1">
              {{ row.detailsShowing ? '&and;' : '&or;'}}
            </b-button>
            <b-button v-else variant="outline-secondary" size="sm" @click="row.toggleDetails" class="mr-1">
              {{ row.detailsShowing ? '&and;' : '&or;'}}
            </b-button>
          </template>
          <template v-slot:row-details="row">
            <b-card bg-variant="light" v-if="row.item.value.addresses && row.item.value.addresses.length>0">
                <b>Wohnadresse</b><br>
                <span v-if="row.item.value && row.item.value.addresses && row.item.value.addresses[0]">{{row.item.value.addresses[0].street}}</span> //
                <span v-if="row.item.value && row.item.value.addresses && row.item.value.addresses[0]">{{row.item.value.addresses[0].zipCode}}</span>&nbsp;
                <span v-if="row.item.value && row.item.value.addresses && row.item.value.addresses[0]">{{row.item.value.addresses[0].city}}</span>

              </b-card>
              <b-card v-if="row.item.value.cards && row.item.value.cards.length>0">
              <b>Produkte</b><br>
              <div v-for="card in row.item.value.cards" :key="card.id">
                <b-icon icon="credit-card" font-scale="1.6"></b-icon>&nbsp;
                <span v-if="card.type == 'MAESTRO'">
                  BLZ {{card.bankAccount.bank}} // Konto {{card.bankAccount.accountNumber}} // {{card.type}} // {{card.cardNumber}}
                </span>
                <span v-else>
                  {{card.type}} // {{card.cardNumber}}
                </span>
              </div>
            </b-card>
          </template>
        </b-table>
      </b-card>
  </div>
</template>

<script>

export default {
  name: 'CustomerBox',
  components: {
  },
  data() {
    return {
      fields: [
        { key: 'value.firstName', label: 'Vorname' },
        { key: 'value.lastName', label: 'Nachname' },
        { key: 'value.birthday', label: 'Geb.Datum' },
        'info'
        ],
      user: { gebDat: '31.10.1984', vorname: 'Max', nachname: 'Müller', strasse: 'Hasnerstrasse 10', ort: '4020 Linz' },
    }
  },
  methods: {
    rowClass(item, type) {
      if (!item || type !== 'row') return
      if(item.confidence.level == 1 ) return 'table-success'
    }
  },
  computed: {
    affectedPersonCandidates () {
      if( this.$store.state.dialogState  &&
          this.$store.state.dialogState.slots &&
          this.$store.state.dialogState.slots.AffectedPerson && this.$store.state.dialogState.slots.AffectedPerson.candidateValues )
        return this.$store.state.dialogState.slots.AffectedPerson.candidateValues;
      else
        return null;
    }
  }
}
</script>

<style scoped>

</style>
